<template>
    <div v-if="series">
        <CardRowText
            :label="$t('notes-appointment-rules')"
            :text="valueToString(series.notesAppointmentRules)"
            :has-border-bottom="true"
        />
        <CardRowText :label="$t('notes-months')" :text="valueToString(series.notesMonths)" :has-border-bottom="true" />
        <CardRowText
            :label="$t('notes-holidays-nrw')"
            :text="valueToString(series.notesHolidaysNrw)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('notes-holidays-national')"
            :text="valueToString(series.notesHolidaysNational)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('notes-holidays-international')"
            :text="valueToString(series.notesHolidaysInternational)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('notes-public-holidays-nrw')"
            :text="valueToString(series.notesPublicHolidaysNrw)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('notes-public-holidays-national')"
            :text="valueToString(series.notesPublicHolidaysNational)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('notes-public-holidays-international')"
            :text="valueToString(series.notesPublicHolidaysInternational)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('other-notes-appointment-rules')"
            :text="valueToString(series.otherNotesAppointmentRules)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('appointment-history')"
            :text="valueToString(series.appointmentHistory)"
            :has-border-bottom="false"
        />
    </div>
</template>
<script setup lang="ts">
import CardRowText from '@/components/Card/CardRowText.vue';
import { useEventSeries } from '@/event/composables/useEventSeries';
import { valueToString } from '@/forms/forms';
import { computed } from 'vue';

const props = defineProps<{ seriesId: string }>();

const seriesId = computed(() => props.seriesId);
const { series } = useEventSeries(seriesId);
</script>
